module.exports = __webpack_public_path__ + "media/icons/naped-tyl-blue@2x-6b8524f9.png";